const phonebrand = {
  getlist: 'phonebrand/getlist',
  add: 'phonebrand/add',
  update: 'phonebrand/update',
  remove: 'phonebrand/remove',
  get: 'phonebrand/get',
  getall: 'phonebrand/getall',
  clearcache: 'phonebrand/clear-cache',
}
export default phonebrand
